<template>
  <div class="comment offset">
    <h3 style="font-size: 2.4rem; color: #424242">Comente</h3>
    <div v-for="(comment, index) in comments" :key="'coment' + index">
      <div class="user_box">
        <p class="initials is-size-7" :class="getBackgroundColor(comment.icon)">
          {{ comment.icon }}
        </p>
        <div class="user_info">
          <div class="user_name">{{ comment.nickname }}</div>
          <div class="stars is-size-7 has-text-grey">
            <div class="ratings-dynamic">
              <div class="empty-stars"></div>
              <div class="full-stars" style="width: 100%"></div>
            </div>
            {{ comment.date }}
          </div>
          <div class="user_review has-text-grey" v-html="comment.comment"></div>
        </div>
      </div>
      <hr v-if="index !== comments.length - 1" />
    </div>
  </div>
</template>

<script>
const comments = [
  {
    icon: 'S',
    nickname: 'Shubham Gupta',
    date: '28/04/2024',
    comment:
      'Continua melhorando<br />está muito melhor agora em termos de desafio, jogabilidade e diversão geral que eu recomendaria para iniciantes e especialistas em geral prática. Muitos reclamantes, mas não fraudados, apenas jogadores muito bons nas mesas.<br />Também muito bom atendimento ao cliente',
  },
  {
    icon: 'R',
    nickname: 'Riddhi Sinha',
    date: '13/03/2024',
    comment:
      'Isso funcionou bem com este aplicativo de jogo gratuito se você gosta de pôquer ou sempre quis jogar sem usando seu dinheiro, então este aplicativo é para você, eu pessoalmente gosto deste aplicativo e fiz alguns novos amigos por meio dele em todo o mundo, por favor, não tente alterar este aplicativo de forma alguma, pois ele funciona perfeitamente, não tente consertar algo que está não quebrou como outros aplicativos de jogos fizeram sério.',
  },
  {
    icon: 'K',
    nickname: 'Kannav Bhatia',
    date: '22/12/2023',
    comment:
      'Um ótimo jogo para fins de entretenimento, mas também brilhante para qualquer pessoa como eu que deseja desenvolver seu jogo de pôquer, as rodadas diárias são ótimas se você precisar de algumas fichas para voltar à ação sem gastar nenhum dinheiro. Já recomendei esse aplicativo para algumas pessoas!',
  },
  {
    icon: 'S',
    nickname: 'Samshuddin Ahmed',
    date: '16/11/2023',
    comment:
      'Ótimo jogo<br>Eu acho engraçado como as pessoas dizem que este é o melhor aplicativo de pôquer que existe e depois viram a rodada e reclamam do algoritmo quando perdem se você jogar 4 divertido, é muito divertido. Desculpe, alguns de vocês não<br>se divertindo. Adoro esse aplicativo dou 5 estrelas',
  },
];
export default {
  data() {
    return {
      comments,
    };
  },
  methods: {
    getBackgroundColor(icon) {
      switch (icon) {
        case 'S':
          return 'pink';
        case 'R':
          return 'blue';
        case 'K':
          return 'grey';
        default:
          return 'pink';
      }
    },
  },
};
</script>
<style scoped>
.user_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.initials {
  height: 3rem;
  width: 3rem;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  box-shadow: 0 0.1rem 0.2rem #8d8d8d;
  margin-right: 1.4rem;
  text-transform: capitalize;
  box-sizing: border-box;
  padding-top: 0.3rem;
}

.user_info {
  width: 84%;
}
.user_name {
  font-style: normal;
  font-stretch: normal;
  line-height: 1.3;
  letter-spacing: normal;
  margin-bottom: 0;
  font-size: 1.8em;
  font-weight: 400;
  text-transform: capitalize;
  font-weight: 600;
  font-family: NotoSansHansRegular;
  color: #1a1a1a;
}
.user_review {
  font-family: NotoSansHansRegular;
  font-size: 1.4rem;
  color: #797d8a;
}
.stars {
  padding: 0.6rem 0;
  font-family: NotoSansHansRegular;
  color: #585e6e;
  font-size: 1.4rem;
}

.pink {
  background-color: #c33f5c;
}
.grey {
  background-color: #78929d;
}
.blue {
  background-color: #5d6ac0;
}
.comment {
  width: 100%;
  height: auto;

  padding-bottom: 7rem;
}
.comment hr {
  margin-top: 1.8rem;
  margin-bottom: 1.8rem;
  border-top: 1px solid #f5f5f5;
}
</style>
